import React from 'react';
import { Loading } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import { statusOptions } from '../../identical';

export default function Description({ loading, detail, onNoteChange }) {
  return (
    <Loading loading={loading}>
      <Descriptions style={{ marginTop: 14 }} title='基本信息' emptySuffix='-'>
        <Descriptions.Item label='任务名称' value={detail.functionName} />
        <Descriptions.Item label='命名空间' value={detail.namespace} />
        <Descriptions.Item label='所属租户' value={detail.tenant} />
        <Descriptions.Item label='任务类型' value={detail.runtime} />
        <Descriptions.Item
          label='任务状态'
          value={detail.status}
          type='statusOptions'
          options={statusOptions}
        />
        <Descriptions.Item label='归属集群' value={detail.clusterName} />
        <Descriptions.Item label='创建时间' value={detail.createTime} type='datetime' />
        <Descriptions.Item label='包地址' span={3} value={detail.packageURL} />
        <Descriptions.Item label='函数入口' span={3} value={detail.className} />
        <Descriptions.Item
          label='备注'
          span={3}
          value={detail.note}
          editable
          onChange={onNoteChange}
        />
      </Descriptions>
    </Loading>
  );
}
